/**
 * Taipei Toy Festival pre-orders — public API calls.
 */

const parseJson = async (response, fallbackMessage) => {
  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    throw new Error(fallbackMessage);
  }
  const data = await response.json();
  if (!response.ok || data?.success === false) {
    throw new Error(data?.error || fallbackMessage);
  }
  return data.data;
};

const postJson = (url, body) =>
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

export const fetchTtfCatalog = async () =>
  parseJson(await fetch('/api/ttf-pieces'), 'No se pudo cargar el catálogo.');

export const createTtfOrder = async (body) =>
  parseJson(await postJson('/api/ttf-orders', body), 'No se pudo crear el pedido.');

export const createTtfPieceRequest = async (body) =>
  parseJson(await postJson('/api/ttf-piece-requests', body), 'No se pudo enviar tu solicitud.');
